import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators,FormControl} from '@angular/forms';
import { Router } from '@angular/router';
import { MatSelect } from '@angular/material/select';
import { Storage } from '@ionic/storage';
import { ToastController, LoadingController,MenuController, Platform } from '@ionic/angular';
import {Network} from '@ionic-native/network/ngx';
import {Helper} from '../services/Helper';
import { APIService } from '../services/APIService';
import { Register } from '../models/Register';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {



  registerinfo: Register;
  credentialsForm: FormGroup;
  Regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  loader: any;
  successvalue:any;
  pwdHide:true;
  checked = true;
  gender :any;
  dob:any;
  fcmToken:any;

  constructor(private formBuilder: FormBuilder, private router:Router,private storage: Storage,public toastController: ToastController,private network: Network,public loadingController: LoadingController,public helper: Helper,private apiservice: APIService,private menuCtrl:MenuController, private platform:Platform) {

    
    this.platform.backButton.subscribeWithPriority(1, () => {
      this.router.navigate(['/login']);
});


  


    this.credentialsForm = this.formBuilder.group({
      fname: ['', Validators.compose([])],
      lname: ['', Validators.compose([])],
      email: ['', []],
      mobile: [
        '', Validators.compose([
          Validators.pattern(this.Regex),
         
        ])
      ],
      // password: ['', [
      //   Validators.required, 
      //   Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')
      //   ]],
      // password: ['', [
      //   Validators.required, 
      //   Validators.minLength(8)
      //   ]],      
    });

    this.registerinfo = new Register();


   }

  ngOnInit() {
  }

  login(){
    this.router.navigate(['/login']);
  }

  ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }


  register(value: any){
    console.log(value);
        if (!value.fname || !this.credentialsForm.controls.fname) {
          this.helper.presentToast('Please Enter First Name!');  }
        else if(!value.lname || !this.credentialsForm.controls.lname) {
          this.helper.presentToast('Please Enter Last Name!'); }
        else if (!value.email || !this.credentialsForm.controls.email) {
          this .helper.presentToast('Please Enter Email address!'); }
        else if (!value.mobile || !this.credentialsForm.controls.mobile) {
          this.helper.presentToast('Please Enter Mobile Number!'); }
        // else if (!value.password || !this.credentialsForm.controls.password) {
        //   this.helper.presentToast('Please Enter password!'); }
          else if (!this.gender ) {
            this.helper.presentToast('Please Enter gender'); }
            else if (!this.dob ) {
              this.helper.presentToast('Please Enter date of Birth'); }
    else{


       
      this.registerinfo.firstname=value.fname;
      this.registerinfo.lastname=value.lname;
      this.registerinfo.email=value.email;
      this.registerinfo.phone=value.mobile;
     // this.registerinfo.password=value.password;
      this.registerinfo.gender=this.gender;
      this.registerinfo.dob=this.dob;

      console.log(this.registerinfo);



      this.presentLoading().then(() => {
        this.apiservice.otpregister({"phone":this.registerinfo.phone.toString()}).subscribe(
            response => {
                if (response.body.message.status == 201) {
                    
                  this.registerinfo.otp = response.body.message.otp;
                  this.storage.set("registerinfo",this.registerinfo);
                  
                    this.dismissLoading();
                    this.router.navigate(['/register-otp']);

                }
            }, error => {
                this.dismissLoading();
                this.helper.presentToastError(error.error.message.message);
            });
      });


      
    }
       
        }



        async presentLoading() {
          this.loader = await this.loadingController.create({
              translucent: true
          });
          await this.loader.present();
      }
      
      async dismissLoading() {
        await this.loader.dismiss();
      }








}
